<template>
  <form
    ref="form"
    v-bind="attrs"
    :action="action"
    :accept-charset="acceptCharset"
    :method="method"
  >
    <input
      v-if="csrfToken"
      type="hidden"
      name="authenticity_token"
      autocomplete="off"
      :value="csrfToken"
    />
    <slot />
  </form>
</template>

<script setup lang="ts">
import { ref, useAttrs, watch } from 'vue'

interface Props {
  acceptCharset?: string
  action?: string
  csrfToken?: string
  method?: string
  shouldSubmit?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  acceptCharset: 'UTF-8',
  action: '',
  csrfToken: '',
  method: 'post',
})

const attrs = useAttrs()

const form = ref<HTMLFormElement | null>(null)

watch(
  () => props.shouldSubmit,
  (shouldSubmit) => {
    if (shouldSubmit && form.value) {
      form.value.submit()
    }
  }
)
</script>
